import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    console.log('Parallax controller connected')
    console.log('Has image target:', this.hasImageTarget)
    console.log('Image target element:', this.imageTarget)
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    this.handleScroll() // Initialize
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    if (!this.hasImageTarget) {
      console.log('No image target found')
      return
    }

    const speed = 0.5 // Parallax speed (0.5 = half speed of scroll)
    const rect = this.element.getBoundingClientRect()
    const windowHeight = window.innerHeight
    
    // Check if element is in viewport
    if (rect.top < windowHeight && rect.bottom > 0) {
      // Simple calculation: move based on distance from top of viewport
      const scrollPercent = (windowHeight - rect.top) / (windowHeight + rect.height)
      const yPos = scrollPercent * 100 * speed
      
      console.log('Applying parallax:', yPos)
      this.imageTarget.style.transform = `translateY(${yPos}px)`
    }
  }
}
